export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/models/payment/scheduling.ts